window.$ = jQuery;
import { default as Common } from './modules/common.js';
import { default as Accordion } from './modules/accordion.js';
import { default as Animation } from './modules/animation.js';
import { default as Breadcrumb } from './modules/breadcrumb.js';
import { default as Collapse } from './modules/collapse.js';
import { default as Modals } from './modules/modals.js';
import { default as Sliders } from './modules/sliders.js';
import { default as Tabs } from './modules/tabs.js';
import { default as Video } from './modules/video.js';
import { default as Nav } from './modules/nav.js';

const modules = {
	Common,
	Accordion,
	Animation,
	Breadcrumb,
	Collapse,
	Modals,
	Sliders,
	Tabs,
	Video,
	Nav,
};

Object.keys(modules).forEach(key => {
	modules[key].init();
	window[key] = modules[key];
});